import { cva } from "class-variance-authority";

export type FeedbackThumbState = "idle" | "selectedPositive" | "selectedNegative";

export const messageFeedbackStyles = {
  root: "flex items-center gap-1",
  thumb: cva("rounded p-1 disabled:opacity-50", {
    variants: {
      state: {
        idle: "text-subtle hover:bg-muted hover:text-muted-foreground",
        selectedPositive: "text-teal",
        selectedNegative: "text-destructive",
      } satisfies Record<FeedbackThumbState, string>,
    },
    defaultVariants: { state: "idle" },
  }),
  status: "ml-1 text-xxs text-subtle",
  retryBtn:
    "ml-1 text-xxs font-semibold text-teal underline underline-offset-2 hover:text-muted-foreground",
};
